const displayValue = (value) => String(value || "").trim() || "Not recorded";

const formatDate = (value) => {
  const parts = String(value || "").split("-");
  if (parts.length !== 3) return displayValue(value);
  const date = new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
  return Number.isNaN(date.getTime())
    ? displayValue(value)
    : date.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
};

const formatTime = (value) => {
  const text = String(value || "").trim();
  if (!text) return "Not recorded";
  if (/\b(?:AM|PM)\b/i.test(text)) return text.toUpperCase();
  const match = text.match(/^(\d{1,2}):(\d{2})/);
  if (!match) return text;
  const hours = Number(match[1]);
  const suffix = hours >= 12 ? "PM" : "AM";
  return `${hours % 12 || 12}:${match[2]} ${suffix}`;
};

const getSummaryItems = (patient) => [
  { label: "Patient Name", values: [displayValue(patient.customer_name)], image: "/assets/screen1-assets/User.webp" },
  { label: "Patient ID", values: [displayValue(patient.patient_id)], image: "/assets/screen1-assets/Passport_ID.webp" },
  { label: "Appointment Type", values: [displayValue(patient.disposition)], image: "/assets/screen1-assets/therapy.webp" },
  { label: "Treatment / Issue", values: [displayValue(patient.treatment || patient.hospital_issue)], image: "/assets/screen1-assets/therapy_taken.webp" },
  { label: "Doctor / Therapist", values: [displayValue(patient.doctor_name)], image: "/assets/screen1-assets/Therapist_Name.webp" },
  { label: "Date & Time", values: [formatDate(patient.appointment_date), formatTime(patient.appointment_time)], image: "/assets/screen1-assets/Date_Time.webp" },
  { label: "Center", values: [displayValue(patient.center_name)], image: "/assets/screen1-assets/Duration.webp" },
  { label: "Contact Number", values: [displayValue(patient.phone_number), patient.alternate_phone_number ? `Alternate: ${patient.alternate_phone_number}` : ""].filter(Boolean), image: "/assets/screen1-assets/Next_Follow_up.webp" },
];

function LotusMark({ className = "" }) {
  return (
    <svg
      className={`lotus-mark ${className}`}
      viewBox="0 0 64 34"
      aria-hidden="true"
    >
      <g
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.8"
      >
        <path d="M32 27C24 22 20 14 24 5c6 4 8 11 8 22Z" />
        <path d="M32 27c8-5 12-13 8-22-6 4-8 11-8 22Z" />
        <path d="M30 27C20 26 13 20 12 12c8 0 14 5 18 15Z" />
        <path d="M34 27c10-1 17-7 18-15-8 0-14 5-18 15Z" />
        <path d="M32 28c-12 0-20-4-24-11 9-2 18 2 24 11Z" />
        <path d="M32 28c12 0 20-4 24-11-9-2-18 2-24 11Z" />
      </g>
    </svg>
  );
}

const ScreenOne = ({ patient }) => {
  const summaryItems = getSummaryItems(patient);
  return (
    <section className="screen-one" aria-labelledby="screen-one-title">
      <aside className="screen-one__intro left-side">
        <h1 id="screen-one-title">
          <strong>Patient &amp; Session</strong>
          <span>Summary</span>
        </h1>
        <img
          className="screen-one__divider"
          src="/assets/screen1-assets/line.webp"
          alt=""
          aria-hidden="true"
        />
        <p>Personalized Care. Holistic Healing.</p>
      </aside>

      <div className="content-side">
        <div className="screen-one__main main-content">
        <div className="summary-grid">
          {summaryItems.map((item) => (
            <article className="summary-card" key={item.label}>
              <img src={item.image} alt="" aria-hidden="true" />
              <div>
                <small>{item.label}</small>
                <strong>
                  {item.values.map((value, index) => (
                    <span
                      className={index > 0 ? "summary-card__secondary" : ""}
                      key={value}
                    >
                      {value}
                    </span>
                  ))}
                </strong>
              </div>
            </article>
          ))}
        </div>

        <section
          className="wellness-banner"
          aria-label="Your wellness. Our priority. Together, we create lasting well-being."
        >
          <img
            className="wellness-banner__leaf wellness-banner__leaf--left"
            src="/assets/screen1-assets/Leaf_02.webp"
            alt=""
            aria-hidden="true"
          />

          <div className="wellness-banner__message">
            <LotusMark className="wellness-banner__lotus--top" />
            <h2>Your wellness. Our priority.</h2>
            <p>Together, we create lasting well-being.</p>
            <div className="wellness-banner__divider" aria-hidden="true">
              <span />
              <LotusMark className="wellness-banner__lotus--small" />
              <span />
            </div>
          </div>

          <img
            className="wellness-banner__leaf wellness-banner__leaf--right"
            src="/assets/screen1-assets/Leaf_01.webp"
            alt=""
            aria-hidden="true"
          />
        </section>
        </div>
      </div>
    </section>
  );
}

export default ScreenOne;
